module.exports = __webpack_public_path__ + "public/img/face.c91c611d.png";